import LayerGroup from "ol/layer/Group";
import LayerTile from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";

//IUUF
import iuuf_2026Q1 from "./iuuf_2026Q1";
import iuuf_2026Q2 from "./iuuf_2026Q2";

const karagatanURL = process.env.GEOSERVER;

const iuuf = new LayerGroup({
  title:
    '<a href="/comreport/index.html" target="_blank" rel="noopener noreferrer">Community Reported Coastal and Fisheries Issues</a>',
  fold: "close",
  layers: [
    iuuf_2026Q1,
    iuuf_2026Q2,
    new LayerTile({
      title: "5-km Grid Reference",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:philgrid_5km",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
  ],
});

export default iuuf;
